import FuseAnimate from "../fuse-animate/fuse-animate";
import React from "react";


const StripeCardError = ({error}) => {

    if (!error) {
        //console.log('no error!')
        return null
    }

    // It's a 'payment required' card error, handle it here.
    switch (error.code) {
        case 'card_declined':
            if (error.message.indexOf('insufficient') > -1) {
                error.code = 'insufficient_funds'
            }
            break;

        case 'incorrect_cvc':
        case 'expired_card':
            break;

        default:
            error.code  = 'generic'
            break;
    }

    return (
        <FuseAnimate animation="transition.expandIn" delay={100}>
            <div className="flex flex-row rounded bg-red-200 p-3 my-2">
            { error.code === 'incorrect_cvc' ?
                <div className="">
                    <div className="text-md font-bold mb-1">Your card's security code is incorrect.</div>
                    <div className="text-xs">
                        Check the CVC code and try again.
                    </div>
                </div>
                : null
            }
            { error.code === 'expired_card' ?
                <div className="">
                    <div className="text-md font-bold mb-1">Your card has expired.</div>
                    <div className="text-xs">
                        Update your card details and try again.
                    </div>
                </div>
                : null
            }
            { error.code === 'insufficient_funds' ?
                <div className="">
                    <div className="text-md font-bold mb-1">Your card has insufficient funds.</div>
                    <div className="text-xs">
                        Check your card is unlocked for online use and there is enough money
                        available in your bank account.
                    </div>
                </div>
                : null
            }
            { error.code === 'card_declined' ?
                <div className="">
                    <div className="text-md font-bold mb-1">Your card was declined.</div>
                    <div className="text-xs">
                        We don't know why exactly - banks don't give us much information for privacy reasons. You may need to
                        contact your bank to find out why the card was declined.
                    </div>
                </div>
                : null
            }
            { error.code === 'generic' ?
                <div className="">
                    <div className="text-md font-bold mb-1">Sorry, something went wrong.</div>
                    <div className="text-xs">
                        {error.message}
                    </div>
                </div>
                : null
            }
            </div>
        </FuseAnimate>
    )
}

export default StripeCardError;